import { api } from "../api/client";
import type { LogEntry } from "../crypto/webvh";

/** A did:webvh's log from the rail (GET /did/{did}/log, JSON Lines). */
export async function fetchDidLog(did: string): Promise<LogEntry[]> {
  const r = await api.GET("/did/{did}/log", { params: { path: { did } }, parseAs: "text" });
  if (!r.response.ok) throw new Error("could not read your DID's log");
  return String(r.data).split("\n").filter(Boolean).map((l) => JSON.parse(l));
}
